import React from 'react';
import { useAuth } from '../hooks/useAuth';

export default function SettingsPage() {
  const { user, tenantSlug, role } = useAuth();

  return (
    <div>
      <h2 style={{ fontSize: '1.5rem', fontWeight: 700, margin: '0 0 1.5rem', color: '#111827' }}>Settings</h2>

      <div style={{ backgroundColor: '#fff', borderRadius: '0.5rem', border: '1px solid #e5e7eb', padding: '1.25rem' }}>
        <h3 style={{ fontSize: '1rem', fontWeight: 600, margin: '0 0 1rem' }}>Account</h3>

        <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '0.75rem', fontSize: '0.875rem' }}>
          <span style={{ color: '#6b7280', fontWeight: 500 }}>Name</span>
          <span>{user?.name || '—'}</span>

          <span style={{ color: '#6b7280', fontWeight: 500 }}>Email</span>
          <span>{user?.email || '—'}</span>

          <span style={{ color: '#6b7280', fontWeight: 500 }}>Tenant</span>
          <span>{tenantSlug || '—'}</span>

          <span style={{ color: '#6b7280', fontWeight: 500 }}>Role</span>
          <span style={{ textTransform: 'capitalize' }}>{role || '—'}</span>

          <span style={{ color: '#6b7280', fontWeight: 500 }}>Auth</span>
          <span>{user?.auth_provider || '—'}</span>
        </div>
      </div>
    </div>
  );
}
